<template>
  <div class="app-container">
    <div class="nav-title">
      <img src="@/assets/arrow-left.png" class="arrow" @click="navBack" />
      <span class="title-text">{{ title }}</span>
    </div>

    <div class="main-content">
      <div class="article">
        <div v-show="buyVideoShow">
          <video controls height="100%" src="@/assets/buy_video.mp4"></video>
          <img width="100%" src="@/assets/buy_pic.jpg" alt="buy_pic" />
        </div>
        <div v-show="sellVideoShow">
          <video controls height="100%" src="@/assets/sell_video.mp4"></video>
          <img width="100%" src="@/assets/sell_pic.jpg" alt="buy_pic" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Article",
  data() {
    return {
      qrcode: "",
      title: "",
      content: "",
      buyVideoShow: false,
      sellVideoShow: false,
    };
  },
  created() {
    const type = this.$route.params.type;
    const id = this.$route.params.id;
    if ("video" === type) {
      this.getVideoDetail(id);
    }
  },
  mounted() {
    // document.documentElement.style.fontSize = '16px'
  },
  methods: {
    getArticleInfo(id) {
      getArticle(id).then((res) => {
        this.title = res.title;
        this.content = res.content;
      });
    },
    getVideoDetail(code) {
      if ("buy_course" == code) {
        this.title = "交易买币";
        this.sellVideoShow = false;
        this.buyVideoShow = true;
      } else if ("sell_course" == code) {
        this.title = "挂单卖币";
        this.buyVideoShow = false;
        this.sellVideoShow = true;
      }
    },
    navBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background-color: #000;

  .nav-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.12667rem;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: #000;
    .title-text {
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.48rem;
      font-style: normal;
      font-weight: 400;
    }
    .arrow {
      position: absolute;
      left: 0.43rem;
      top: 50%;
      transform: translateY(-50%);
      height: 0.37333rem;
      width: 0.18667rem;
    }
  }

  .main-content {
    padding-top: 1.12667rem;
    .article {
      padding: 0.94rem;
      border-radius: 0.625rem;
      background: #141414;

      ::v-deep p {
        color: #fff;
        margin: 0;
      }
      ::v-deep video {
        width: 100% !important;
        // height: auto;
        object-fit: contain;
      }
      ::v-deep img {
        max-width: 100% !important;
        object-fit: contain;
      }
    }
  }
}
</style>
